import { Link } from 'react-router-dom';

export const CategoryCard = ({
  image,
  description,
  title,
  link,
  buttonText = 'SHOP NOW',
  maxImageWidth = '300px',
}) => {
  return (
    <div className="bg-[#F5F5F7] rounded-xl p-8 flex flex-col items-center justify-end">
      <img
        src={image}
        alt={title}
        className="w-full mb-6"
        style={{ maxWidth: maxImageWidth }}
        loading="lazy"
      />
      <div className="text-center">
        <p className="text-sm text-[#222224] mb-2 text-center">{description}</p>
        <h4 className="text-2xl font-bold mb-4 text-center">{title}</h4>
        <Link
          to={link}
          className="bg-[#FFDE11] px-6 py-2 rounded-full text-sm font-semibold hover:bg-[#e6c800] transition-colors"
        >
          {buttonText}
        </Link>
      </div>
    </div>
  );
};
